import React from 'react';
import PropTypes from 'prop-types';
import prodSpecs from 'lib/nav-product-specs';
import environment from 'lib/environment';
import { MenuItem } from '@getgo/chameleon-web-react-wrapper';
import { ExternalLinkOutlinedIcon } from '@getgo/chameleon-icons/react';
import useAnalytics from 'lib/use-analytics';

export const getProduct = (product, gotoAppEnabled) => {
  const productName = (product === 'g2m' || product === 'g2mfree') ?
    `${product}${gotoAppEnabled ? 'App' : ''}` :
    product;
  return prodSpecs[productName];
};

const RenderProductLink = (props) => {
  const { track } = useAnalytics();
  const prod = getProduct(props.product, props.gotoAppEnabled);
  if (prod) {
    const prodName = prod.product;
    const prodClass = prod.class;
    const prodUrl = environment.get().product[prod.productUrlRef];
    return (
      <a href={prodUrl} id={`${prodName}-nav`} tabIndex="-1" onClick={() => track('Product Link Clicked', { product: prodName })}>
        <MenuItem leadingIcon={prodClass} trailingIcon={<ExternalLinkOutlinedIcon color="type-color-default" />}>
          {prodName}
        </MenuItem>
      </a>
    );
  }
  return null;
};

RenderProductLink.propTypes = {
  product: PropTypes.string.isRequired,
  gotoAppEnabled: PropTypes.bool.isRequired,
};

export default RenderProductLink;
